import { render, staticRenderFns } from "./MapText.vue?vue&type=template&id=0a13633b&"
import script from "./MapText.vue?vue&type=script&lang=ts&"
export * from "./MapText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports